<script context="module">
  /**
   * @enum {NotificationType}
   */
  export const TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
  };
</script>

<script>
  import { createEventDispatcher } from "svelte";
  import Progress from "../components/Progress";
  import Close from "../icons/Close";

  export let title;
  export let description;
  export let progress;
  export let type = "info";
  export let url;

  const dispatch = createEventDispatcher();
</script>

<style>
  .notification {
    margin: 10px 0;
    background-color: rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(209, 208, 197, 0.274);
    overflow: hidden;
    pointer-events: all;
  }

  .notification-title {
    display: flex;
    align-items: center;
    color: #4d505e;
    /* background-color: #eaeaea; */
    font-size: 11px;
    text-transform: uppercase;
  }

  .notification-title-text {
    /* padding-left: 10px; */
    flex: auto;
    font-size: 12px;
    font-weight: 600;
    display: flex;
    align-items: center;
    font-family: sans-serif;
    letter-spacing: 0.5px;
  }

  .notification-body {
    /* padding: 5px 10px; */
  }

  .action-body {
    /* padding: 10px; */
    /* border-top: 1px solid #e4e4e4; */
  }

  .notification-close {
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    outline: none;
    display: flex;
    align-items: center;
    color: #4d505e;
  }
</style>

<div
  class="notification {type} rounded-lg shadow backdrop-blur-sm flex gap-2 p-3">
  <div class="text-midnightBlue-60 flex-none w-12 h-12">
    {#if type === "success"}
      <svg viewBox="0 0 24 24" class=""
        ><path
          d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"
          fill="currentColor" /></svg>
    {:else if type === "error" || type === "warning"}
      <svg viewBox="0 0 24 24"
        ><path
          d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
          fill="currentColor" /></svg>
    {:else if type === "info"}
      <svg viewBox="0 0 24 24"
        ><path
          d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
          fill="currentColor" /></svg>
    {/if}
  </div>
  <div class="flex flex-col flex-auto gap-3 py-3">
    {#if title && title !== ""}
      <div class="notification-title-text">
        {title}
      </div>
    {/if}

    {#if description}
      <div class="notification-body">{description}</div>
    {/if}

    {#if progress}
      <div class="notification-body py-4">
        <Progress {progress} />
      </div>
    {/if}

    {#if url && url != ""}
      <div class="action-body py-4">
        <a class="tc-button __size-small __color-yellow __block" href={url}>
          View
        </a>
      </div>
    {/if}
  </div>

  <button
    aria-label="Close"
    class="notification-close self-start flex-none"
    type="button"
    on:click={(e) => dispatch("closeNotification")}>
    <Close fill="#748D8A" width="16" height="16" />
  </button>
</div>
